export const SectionCard = ({ title, items, customContent }) => (
  <div className="card mb-4 shadow-sm border">
    <div className="card-header bg-light py-3">
      <h3 className="text-secondary fw-bolder">{title}</h3>
    </div>
    <div className="card-body" style={{ fontSize: "16px", lineHeight: "1.7" }}>
      {items ? (
        <ul className="list-unstyled mb-0">
          {items.map((item, index) => (
            <li key={index} className="mb-3">
              {item}
            </li>
          ))}
        </ul>
      ) : (
        customContent
      )}
    </div>
  </div>
);
